var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-video"},[_c('app-full-sticky-bg',{attrs:{"isPlay":""}}),_c('iframe',{attrs:{"src":_vm.url,"allowfullscreen":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }